import { DatabaseObject, Metrics } from "./class";
import { AssetClass } from "./config";

export class FunctionalLocationMetrics extends Metrics {
  children_count: number | null;
}

interface FLOCTreeFilters {
  parent_id: string | null;
  floc_ids?: string[];
  no_superior_functional_location?: boolean | null;
  functional_location_description?: string | null;
}

export class FunctionalLocation extends DatabaseObject {
  static $route = "functional-location";

  metrics: FunctionalLocationMetrics = new FunctionalLocationMetrics();

  functional_location: string;

  parent_id: string | null = null;

  superior_functional_location: string;
  functional_location_description: string;
  construction_type: string;
  planning_plant: string;
  location: string;
  accounting_assesment: string;
  maintenance_plant: string;
  company_code: string;
  cost_center: string;
  planner_group: string;
  planner_group_id: string | null = null;
  sort_field: string;
  main_work_center: string;
  manufacturer: string;
  manufacturer_serial_number: string;
  entity_id: string;
  functional_location_category: string;
  catalog_profile: string;
  object_number: string;
  length: string;

  hide_from_tree_top: boolean = false;

  // Asset Fields
  is_asset: boolean = false;
  hours_per_day: number | null = null;
  asset_class_id: string | null = null;

  asset_class: AssetClass | null = null;

  get is_asset_text() {
    return this.is_asset ? "Yes" : "No";
  }

  get asset_class_name() {
    if (this.asset_class) return this.asset_class.name;
    return "";
  }

  static async importList(fileId: string) {
    await FunctionalLocation.$axios.$post(
      "/functional-location/import-list",
      {},
      { params: { fileId } },
    );
  }

  static async getTreeChildren(filters: FLOCTreeFilters) {
    return FunctionalLocation.fromAxiosList<FunctionalLocation>(
      await FunctionalLocation.$axios.$post<FunctionalLocation[]>(
        "/functional-location/tree",
        filters,
      ),
    );
  }
}
